/* import __COLOCATED_TEMPLATE__ from './market-image-uploader.hbs.js'; */
import { computed } from '@ember/object';
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { resolve } from 'rsvp';
import ValidatedViewSupport from '@dashboard/shared-ui/mixins/validated-view-support'; // eslint-disable-line ember/no-mixins

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend(ValidatedViewSupport, {
  i18n: service(),
  dataApi: service(),
  classNames: ['market-image-uploader'],
  classNameBindings: ['value:image-uploader-is-previewing'],
  value: null,
  reader: null,
  showPreview: true,
  previewUrl: null,
  previewWidth: null,
  previewHeight: null,
  previewClass: null,
  thumbnailAddClass: null,
  canSelectImages: true,
  cantSelectImagesCallback: null,
  showDeleteButton: true,
  showUploadButton: false,
  showUploadButtonOnHover: false,
  showSpinner: false,
  buttonWindowClass: null,
  buttonClass: 'button--blue-link',
  // if the below two parameters are passed in
  // they are used by the locations form (locations/new or locations/:token)
  // to send CDP events
  eventDescription: '',
  selectedLocationToken: null,
  hasPreviewUrl: computed('previewUrl', function () {
    return Boolean(this.previewUrl);
  }),
  init(...args) {
    this._super(...args);
    if (!this.description) {
      this.set('description', '');
    }
    if (!this.button) {
      this.set('button', this.i18n.t('button.upload'));
    }
  },
  confirmDelete: () => resolve(true),
  _thumbnailAddClass: computed('previewUrl', 'thumbnailAddClass', function () {
    if (this.previewUrl) {
      return '';
    }
    return this.thumbnailAddClass || 'image-uploader__thumbnail-add';
  }),
  _previewTitle: computed('previewUrl', function () {
    if (this.previewUrl) {
      return this.i18n.t('imageUploader.filledState.title');
    }
    return this.i18n.t('imageUploader.emptyState.title');
  }),
  didInsertElement(...args) {
    this._super(...args);
    this.reader = new FileReader();
    this._bindFileInputListeners();
    this._bindFileReaderLoadListener();
  },
  willDestroyElement(...args) {
    this._super(...args);
    const imageUploader = this.element.querySelector('input[type="file"]');
    imageUploader.removeEventListener('click', this._boundFileInputClickListener);
    imageUploader.removeEventListener('change', this._boundFileInputChangeListener);
    this._boundFileInputClickListener = null;
    this._boundFileInputChangeListener = null;
    if (this.reader) {
      this.reader.onload = null;
    }
  },
  _bindFileInputListeners() {
    const imageUploader = this.element.querySelector('input[type="file"]');
    this._boundFileInputClickListener = e => {
      if (!this.canSelectImages) {
        this.cantSelectImagesCallback?.();
        e.preventDefault();
      }
    };
    imageUploader.addEventListener('click', this._boundFileInputClickListener);
    this._boundFileInputChangeListener = e => {
      this._fileInputChangeListener(e);
    };
    imageUploader.addEventListener('change', this._boundFileInputChangeListener);
  },
  _bindFileReaderLoadListener() {
    this.reader.onload = e => {
      this._fileReaderLoadListener(e);
    };
  },
  _fileInputChangeListener(e) {
    // The `e.files` fallback is only here for testing, as `target` is readonly
    // checking event.originalEvent for the file is necessary for events triggered by jQuery
    let files;
    if (e.target && e.target.files && e.target.files.length > 0) {
      files = e.target.files;
    } else if (e.originalEvent && e.originalEvent.files && e.originalEvent.files.length > 0) {
      files = e.originalEvent.files;
    } else {
      files = e.files;
    }
    const file = files && files[0];
    if (!file) {
      return;
    }
    this.reader.readAsDataURL(file);
    this.set('value', file);
    if (this.onFileUploaded) {
      this.onFileUploaded(file, this.actions.delete.bind(this));
    }
  },
  _boundFileInputChangeListener: null,
  _boundFileInputClickListener: null,
  _fileReaderLoadListener(e) {
    this.set('previewUrl', e.target.result);
  },
  actions: {
    trackEvent() {
      if (this.eventDescription.length > 0 && this.selectedLocationToken !== null) {
        this.dataApi.track('Click Feature', {
          feature_name: 'Brand at location',
          event_description: `click upload ${this.eventDescription}`,
          additional_parameters: {
            unit_token: this.selectedLocationToken
          }
        });
      }
    },
    openUploadDialog() {
      this.actions.trackEvent();
      this.element.querySelector('input[type="file"]').click();
    },
    delete(e) {
      this.confirmDelete().then(shouldDeleteImage => {
        if (shouldDeleteImage) {
          if (this.eventDescription.length > 0 && this.selectedLocationToken !== null) {
            this.dataApi.track('Click Feature', {
              feature_name: 'Brand at location',
              event_description: `click delete ${this.eventDescription}`,
              additional_parameters: {
                unit_token: this.selectedLocationToken
              }
            });
          }
          this.set('value', null);
          this.set('previewUrl', null);
          this.element.querySelector('input[type="file"]').value = null;
          if (this.delete) {
            this.delete(e);
          }
        }
      });
    }
  }
});